// extracted by mini-css-extract-plugin
export default {"textLoop":"myStyle_textLoop__7QLlW","discr":"myStyle_discr__v3xsr","btnLink":"myStyle_btnLink__l3Ub+","span":"myStyle_span__4bI45"};